var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfIconRrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.94,41.37v.72a1.3,1.3,0,0,1-1.3,1.29H29a1.29,1.29,0,0,1-1.29-1.29v-.72A1.29,1.29,0,0,1,29,40.08H72.64A1.3,1.3,0,0,1,73.94,41.37Zm-1.3,5.38H29a1.3,1.3,0,0,0-1.29,1.3v.71A1.29,1.29,0,0,0,29,50.05H72.64a1.3,1.3,0,0,0,1.3-1.29v-.71A1.3,1.3,0,0,0,72.64,46.75Zm-22,6.67H29a1.3,1.3,0,0,0-1.29,1.3v.71A1.3,1.3,0,0,0,29,56.73H50.64a1.31,1.31,0,0,0,1.3-1.3v-.71A1.3,1.3,0,0,0,50.64,53.42ZM100,50A50,50,0,1,1,50,0,50,50,0,0,1,100,50ZM81.34,47.71c0-13-14-23.46-31.34-23.46S18.66,34.75,18.66,47.71c0,7,4.1,13.29,10.6,17.59C29.08,68,28,73.05,22.4,75.07a.35.35,0,0,0,.12.68A29.49,29.49,0,0,0,40.06,70,40.52,40.52,0,0,0,50,71.17C67.31,71.17,81.34,60.67,81.34,47.71Z",
    fill: "#ffb300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfIconRrm);
export default __webpack_public_path__ + "static/media/bf-icon-rrm.137a8463faa86f6e88548ceea015cb22.svg";
export { ForwardRef as ReactComponent };